import api from "./Interceptor";

const BASE_URL = process.env.REACT_APP_BACKEND_URL;

export const login = async (payload) => {
  try {
    const response = await api.post(`${BASE_URL}/auth/login`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error in login:", error);
    throw error?.response?.data || new Error("Unknown error");
  }
};
